import { useEffect, useState } from 'react';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import NotificationItem from './components/NotificationItem';
import LoadingComponent from '../../../Components/LoadingComponent';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { FaBell } from 'react-icons/fa';

function Notification() {
  const [notifications, setNotifications] = useState([]);
  const [loadingNotification, setLoadingNotification] = useState(true);

  useEffect(() => {
    try {
      dayjs.extend(relativeTime);
      setLoadingNotification(true);
      const getNotificationList = async () => {
        let response = await fetchWrapper.get('/notification/');
        setNotifications(response.data.results);
      };
      getNotificationList();
      setLoadingNotification(false);
    } catch (err) {
      setLoadingNotification(false);
      console.log(err);
    }
  }, []);

  return (
    <div className="card content-section event-activity-wrapper">
      <div className="card-header d-flex justify-content-between">
        <div className="">
          <h3 className="d-flex align-items-center text-primary">
            <FaBell size={25} /> Notifications
          </h3>
        </div>
        <div className="d-flex justify-content-between align-items-end">Filters</div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-lg-12">
            <h5 className="mb-6">Recent</h5>
            <div className="list-group list-group-flush list-group-borderless mx-4">
              {loadingNotification ? (
                <LoadingComponent />
              ) : (
                notifications.map((notification, index) => {
                  return (
                    <NotificationItem
                      key={index}
                      type={notification.type}
                      text={notification.text}
                      redirect={notification.redirect}
                      isRead={notification.read}
                      time={dayjs(notification.created_at).fromNow()}
                    />
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notification;
